<div class="p-4 bg-white">
  <div class="flex items-center justify-between mb-4">
    <ui-paragraph
      class="flex-none"
      type="p20"
      mobile-type="p20"
      font-weight="semibold"
      text-color="neutrals-900"
    >
      Funnel
    </ui-paragraph>
    <div class="flex items-center gap-2">
      <ui-paragraph
        class="flex-none"
        type="p12"
        mobile-type="p12"
        font-weight="regular"
        text-color="neutrals-600"
      >
        Archivados
      </ui-paragraph>
      <div class="w-3 h-3 rounded-full bg-black"></div>
    </div>
  </div>

  <div class="grid grid-cols-7 items-start gap-2 h-[420px] overflow-y-visible">
    <!-- 🔹 Primer nivel: columnas del funnel -->
    <div
      *ngFor="
        let column of funnelData;
        let colIndex = index;
        trackBy: trackByColumn
      "
      class="flex flex-col justify-end relative group column-wrapper"
      style="min-width: 120px"
    >
      <!-- 🔹 Segundo nivel: etapas dentro de la columna -->
      <div
        *ngFor="let stage of column; let sIndex = index; trackBy: trackByStage"
        class="bar text-white font-bold flex flex-col relative"
        [style.background]="stage.color"
        [style.height.px]="getStageHeight(stage, colIndex, sIndex)"
        [style.borderTopLeftRadius.px]="sIndex === 0 ? 8 : 0"
        [style.borderTopRightRadius.px]="sIndex === 0 ? 8 : 0"
        [style.borderBottomLeftRadius.px]="sIndex === column.length - 1 ? 8 : 0"
        [style.borderBottomRightRadius.px]="
          sIndex === column.length - 1 ? 8 : 0
        "
        (mouseover)="showTooltip(stage)"
        (mouseout)="hideTooltip(stage)"
      >
        <!-- Tooltip -->
        <div
          *ngIf="
            stage.showTooltip &&
            (stage.name !== 'S/A' ||
              !activeBulkMessage ||
              (stage.name === 'S/A' &&
                leadsWithoutTemplate.length === 0 &&
                leadsWithTemplate.length === 0))
          "
          class="custom-tooltip custom-tooltip-info"
        >
          <div class="flex justify-between">
            <ui-paragraph
              type="p12"
              font-weight="semibold"
              text-color="neutrals-900"
            >
              {{ stage.name }}:
            </ui-paragraph>
            <ui-paragraph
              type="p12"
              font-weight="semibold"
              text-color="neutrals-900"
            >
              {{ stage.count }}
            </ui-paragraph>
          </div>
          <div class="flex justify-between">
            <ui-paragraph
              type="p10"
              font-weight="regular"
              text-color="neutrals-900"
            >
              Porcentaje:
            </ui-paragraph>
            <ui-paragraph
              type="p10"
              font-weight="regular"
              text-color="neutrals-900"
            >
              {{ stage.percentage }}%
            </ui-paragraph>
          </div>
          <div class="mt-2 mb-2">
            <unicon-percent-indicator
              [positive]="stage.relativeChange >= 0"
              [percent]="stage.relativeChange"
            ></unicon-percent-indicator>
          </div>
          <div class="tooltip-arrow" aria-hidden="true"></div>
        </div>

        <!-- Tooltip 2-->
        <div
          *ngIf="
            stage.showTooltip &&
            stage.name === 'S/A' &&
            activeBulkMessage &&
            (leadsWithoutTemplate.length > 0 || leadsWithTemplate.length > 0)
          "
          class="custom-tooltip custom-tooltip-bulk"
          (mouseenter)="showTooltip(stage)"
          (mouseleave)="hideTooltipBulk(stage)"
        >
          <ui-paragraph type="p14" font-weight="bold" text-color="neutrals-900">
            Tienes leads esperando 🚀.
          </ui-paragraph>
          <ui-paragraph
            type="p12"
            font-weight="semibold"
            text-color="neutrals-900"
          >
            Responde a todos con un mensaje automático en segundos.
          </ui-paragraph>
          <div class="mt-2 mb-2 flex justify-end">
            <button
              (click)="showModalResponse(stage.name, stage.count)"
              class="bg-unicon-yellow-100 rounded-[6px] border-[1px] border-unicon-yellow-100 box-border min-h-[40px] h-[40px] hover:opacity-85 w-[120px] flex justify-center items-center cursor-pointer"
            >
              <ui-paragraph
                type="p10"
                mobile-type="p10"
                font-weight="semibold"
                text-color="neutrals-900"
              >
                Responder a todos
              </ui-paragraph>
            </button>
          </div>
          <div class="tooltip-arrow" aria-hidden="true"></div>
        </div>

        <!-- Contenido de la barra -->
        <div
          class="p-2 text-sm flex"
          [ngClass]="{
            'justify-end': (stage.name | lowercase) === 'archivados',
            'justify-between': (stage.name | lowercase) !== 'archivados',
          }"
        >
          <ui-paragraph
            *ngIf="
              shouldShowStageLabel(colIndex, sIndex, stage) &&
              (stage.name | lowercase) !== 'archivados'
            "
            type="p12"
            font-weight="semibold"
            text-color="neutrals-0"
          >
            {{ stage.name }}
          </ui-paragraph>
          <ui-paragraph
            *ngIf="shouldShowStageLabel(colIndex, sIndex, stage)"
            type="p12"
            font-weight="semibold"
            text-color="neutrals-0"
          >
            {{ stage.count }}
          </ui-paragraph>
        </div>
      </div>
    </div>
  </div>
</div>
